module.exports = __webpack_public_path__ + "static/media/large_logo.bfe1d225.png";